
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_1mnl8_197",
  "arrow-outer": "awsui_arrow-outer_xjuzf_1mnl8_201",
  "arrow-inner": "awsui_arrow-inner_xjuzf_1mnl8_201",
  "refresh": "awsui_refresh_xjuzf_1mnl8_231",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_1mnl8_241",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_1mnl8_241",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_1mnl8_244",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_1mnl8_244",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_1mnl8_247",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_1mnl8_247",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_1mnl8_247",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_1mnl8_247",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_1mnl8_250",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_1mnl8_250",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_1mnl8_250",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_1mnl8_250",
  "body": "awsui_body_xjuzf_1mnl8_352",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_1mnl8_391",
  "has-dismiss": "awsui_has-dismiss_xjuzf_1mnl8_395",
  "dismiss": "awsui_dismiss_xjuzf_1mnl8_400",
  "dismiss-control": "awsui_dismiss-control_xjuzf_1mnl8_408",
  "header-row": "awsui_header-row_xjuzf_1mnl8_412",
  "header": "awsui_header_xjuzf_1mnl8_412",
  "content": "awsui_content_xjuzf_1mnl8_438",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_1mnl8_446",
  "container": "awsui_container_xjuzf_1mnl8_548",
  "container-body": "awsui_container-body_xjuzf_1mnl8_556",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_1mnl8_599",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_1mnl8_604",
  "fixed-width": "awsui_fixed-width_xjuzf_1mnl8_607",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_1mnl8_611",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_1mnl8_618",
  "container-arrow": "awsui_container-arrow_xjuzf_1mnl8_630",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_1mnl8_634",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_1mnl8_634",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_1mnl8_646",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_1mnl8_646",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_1mnl8_658",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_1mnl8_658",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_1mnl8_658",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_1mnl8_658",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_1mnl8_674",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_1mnl8_678",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_1mnl8_682",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_1mnl8_1",
  "root": "awsui_root_xjuzf_1mnl8_828",
  "trigger": "awsui_trigger_xjuzf_1mnl8_864",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_1mnl8_871",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_1mnl8_906",
  "popover-content": "awsui_popover-content_xjuzf_1mnl8_910"
};
  